import { QueryFunction, useQuery } from 'react-query';
import { getNotificationPreferences, NotificationPreferences } from '../../services/apiSLTP/notifications';

const fetchNotificationPreferences: QueryFunction<NotificationPreferences> = async () => {
    const response = await getNotificationPreferences();
    return response.data;
};

export const useNotificationPreferencesQuery = () => {
    return useQuery(['notificationPreferences'], fetchNotificationPreferences);
};
